import { createTestIds } from '../../utils';

export const getAlertTestIds = createTestIds('alert', [] as const);
export const getCountTestIds = createTestIds('count', [] as const);
export const getKeyboardTestIds = createTestIds('keyboard', [] as const);
export const getSelectableTestIds = createTestIds('selectable', ['remove'] as const);
export const getStatusTestIds = createTestIds('status', [] as const);
export const getTagTestIds = createTestIds('tag', [] as const);
